import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import styled from "styled-components";
import ContactContent from "../src/components/contact/ContactContent";
import WaveLayout from "../src/layouts/WaweLayout";
import { deviceMax } from '../styles/device';

const Iletisim: NextPage = () => {
    return (
        <React.Fragment>

            <HtmlHead
                pageTitle={'İletişim | Pembe Panjur'}
                description={'Pembe Panjur iletişim sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'}
                        hamburgerMenuType={'black'} registerButton={false} loginButtonText={true} loginButtonMenu={true}>
                <ContactWrapper>
                    <ContactContent/>
                </ContactWrapper>
            </WaveLayout>

        </React.Fragment>
    )
}

const ContactWrapper = styled.div`
  position: relative;
  padding: 0 19px 40px 19px;
  
    @media ${deviceMax.tablet} {
      padding-top: 70px;
      padding-bottom: 0;
    }
`;


import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default Iletisim;
